import { Component, inject, Injector, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { MatCardModule } from '@angular/material/card';
import { createCustomElement } from '@angular/elements';
import { MarkerContentComponent } from './pages/map/marker-content/marker-content.component';
import { Title } from '@angular/platform-browser';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MatCardModule,
    FooterComponent,
    HeaderComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  private titleSerice = inject(Title);

  constructor(
    injector: Injector
  ) {
    const MarkerEle = createCustomElement(MarkerContentComponent, {injector});
    customElements.define('advanced-marker-content', MarkerEle);
  }

  ngOnInit(): void {
    this.titleSerice.setTitle(environment.title);
  }
}
